import { IBid, ICarrierApplication, IUser, Maybe } from 'types/graphqlTypes'

export type ICarrierOptionCarrier = Pick<
  ICarrierApplication,
  'id' | 'mcNumber' | 'dotNumber' | 'name'
>

export type ICarrierOption = Pick<
  IBid,
  | 'id'
  | 'amount'
  | 'carrierContactName'
  | 'carrierContactPhone'
  | 'carrierContactPhoneExt'
  | 'carrierContactUserId'
  | 'source'
> & {
  carrierApplication?: Maybe<ICarrierOptionCarrier>
  carrierContactUser?: Maybe<Pick<IUser, 'id'>>
  counterBid?: Maybe<Pick<IBid, 'id' | 'amount' | 'status'>>
  createdBy?: Maybe<Pick<IUser, 'id' | 'fullName'>>
}

export type ICarrierOptionContact = Pick<IUser, 'id' | 'email' | 'fullName' | 'phone'>

export enum ISourceChannel {
  INBOUND_CALL = 'inbound_call',
  INBOUND_EMAIL = 'inbound_email',
  OUTBOUND_CALL = 'outbound_call',
  OUTBOUND_EMAIL = 'outbound_email',
}

export const SOURCE_CHANNEL_LABELS: Record<ISourceChannel, string> = {
  [ISourceChannel.INBOUND_CALL]: 'Inbound Call',
  [ISourceChannel.INBOUND_EMAIL]: 'Inbound Email',
  [ISourceChannel.OUTBOUND_CALL]: 'Outbound Call',
  [ISourceChannel.OUTBOUND_EMAIL]: 'Outbound Email',
}

export enum ISourceSegment {
  DAT = 'dat',
  INTERNAL_RECOMMENDATION = 'internal_recommendation',
  RELATIONSHIP = 'relationship',
  CARRIER_APP = 'carrier_app',
  OTHER_LOADBOARD = 'other_loadboard',
}

export const SOURCE_SEGMENT_LABELS: Record<ISourceSegment, string> = {
  [ISourceSegment.DAT]: 'DAT',
  [ISourceSegment.INTERNAL_RECOMMENDATION]: 'Internal Recommendation',
  [ISourceSegment.RELATIONSHIP]: 'Relationship',
  [ISourceSegment.CARRIER_APP]: 'Carrier App',
  [ISourceSegment.OTHER_LOADBOARD]: 'Other loadboard',
}
